"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueToColour = exports.generateScales = exports.unitsToLabel = exports.ColorMapLegend = exports.dataRounder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const d3_scale_1 = require("d3-scale");
const katex_1 = __importDefault(require("katex"));
const styled_components_1 = __importDefault(require("styled-components"));
require("katex/dist/katex.min.css");
const fontSize = 14;
const unitLabelWidth = 60;
const [width, height] = [450, 24];
const dataRounder = (value) => Math.floor(value * 100) / 100;
exports.dataRounder = dataRounder;
const ColorMapLegend = ({ colorMap, units, marks: configuredMarks, evenlyLabelMarks, displayValue, markTitles, outerContainerWidth, }) => {
    const uniqueId = (0, react_1.useMemo)(() => Math.random().toString(), []);
    const [min, max] = [
        Math.min(...colorMap.map((c) => c[0])),
        Math.max(...colorMap.map((c) => c[0])),
    ];
    const marks = configuredMarks !== null && configuredMarks !== void 0 ? configuredMarks : [...new Set(colorMap.map((c) => c[0]))];
    const widthToUse = outerContainerWidth !== null && outerContainerWidth !== void 0 ? outerContainerWidth : width;
    const totalRange = max - min;
    const totalWidth = widthToUse - height * 2 - ((units === null || units === void 0 ? void 0 : units.length) ? unitLabelWidth : 0);
    const scales = (0, exports.generateScales)(colorMap, totalRange, totalWidth);
    const offset = min < 0 ? Math.abs(min) : -min;
    if (scales.length === 0)
        return (0, jsx_runtime_1.jsx)("div", {});
    return ((0, jsx_runtime_1.jsxs)(ColorMapLegendContainer, Object.assign({ style: {
            display: "flex",
            flexDirection: "row",
            gap: 6,
            height,
            // the flex-end makes sure the legend is always on the right side, when there are neighbouring legends with displayValues
            justifyContent: "flex-end",
        } }, { children: [displayValue && ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                    height,
                    width: 60,
                    borderRadius: height,
                    color: "white",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: `${height}px`,
                    backgroundColor: (0, exports.valueToColour)(displayValue, scales),
                } }, { children: displayValue }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { position: "relative" } }, { children: [(0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: widthToUse, height: height, style: {
                            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
                            borderRadius: height,
                        } }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 0, y: 0, width: height, height: height, fill: scales[0].colors[0] }), (0, jsx_runtime_1.jsx)("rect", { x: widthToUse - unitLabelWidth - height, y: 0, width: height + unitLabelWidth, height: height, fill: scales[scales.length - 1].colors[1] }), (0, jsx_runtime_1.jsxs)("g", Object.assign({ transform: `translate(${height} 0)` }, { children: [!evenlyLabelMarks &&
                                        scales.map((scale, i) => {
                                            const [lower, upper] = [
                                                (scale.range[0] / totalRange) * totalWidth,
                                                (scale.range[1] / totalRange) * totalWidth,
                                            ];
                                            const gradientId = `gradient-${uniqueId}-${scale.range[0]}-${scale.range[1]}`;
                                            const offsetPixels = (offset / totalRange) * totalWidth;
                                            return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsxs)("linearGradient", Object.assign({ id: gradientId, x1: "0%", y1: "0%", x2: "100%", y2: "0%" }, { children: [(0, jsx_runtime_1.jsx)("stop", { offset: "0%", stopColor: scale.colors[0] }), (0, jsx_runtime_1.jsx)("stop", { offset: "100%", stopColor: scale.colors[1] })] }), gradientId), (0, jsx_runtime_1.jsx)("rect", { x: lower + offsetPixels, y: 0, width: upper - lower + 1, height: height, fill: `url(#${gradientId})` })] }, i));
                                        }), evenlyLabelMarks &&
                                        marks.map((mark, i) => {
                                            const nextMark = marks[i + 1];
                                            if (!nextMark)
                                                return (0, jsx_runtime_1.jsx)("g", {}, i);
                                            const startXPoint = (i / (marks.length - 1)) * totalWidth;
                                            const startColour = (0, exports.valueToColour)(mark, scales);
                                            const endXPoint = ((i + 1) / (marks.length - 1)) * totalWidth;
                                            const endColour = (0, exports.valueToColour)(nextMark, scales);
                                            const gradientId = `gradient-${uniqueId}-${mark}-${nextMark}`;
                                            return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsxs)("linearGradient", Object.assign({ id: gradientId, x1: "0%", y1: "0%", x2: "100%", y2: "0%" }, { children: [(0, jsx_runtime_1.jsx)("stop", { offset: "0%", stopColor: startColour }), (0, jsx_runtime_1.jsx)("stop", { offset: "100%", stopColor: endColour })] }), i), (0, jsx_runtime_1.jsx)("rect", { x: startXPoint, y: 0, width: endXPoint - startXPoint + 1, height: height, fill: `url(#${gradientId})` })] }, i));
                                        }), marks.map((mark, i) => {
                                        const markTitle = markTitles === null || markTitles === void 0 ? void 0 : markTitles.find((m) => m[0] === mark);
                                        if (markTitles && markTitles.length > 0 && !markTitle)
                                            return (0, jsx_runtime_1.jsx)("g", {}, i);
                                        const scale = scales.find((s) => s.range[0] <= mark && s.range[1] >= mark);
                                        if (!scale)
                                            return (0, jsx_runtime_1.jsx)("g", {}, i);
                                        const xPoint = evenlyLabelMarks
                                            ? (i / (marks.length - 1)) * totalWidth
                                            : scale.valueToXPoint(mark);
                                        const offsetPixels = (offset / totalRange) * totalWidth;
                                        return ((0, jsx_runtime_1.jsx)("g", { children: (0, jsx_runtime_1.jsx)("text", Object.assign({ x: xPoint + offsetPixels, y: height / 2 + 1, fill: "white", textAnchor: "middle", dominantBaseline: "middle", fontSize: fontSize, style: {
                                                    textShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
                                                    fontWeight: 600,
                                                } }, { children: markTitle ? markTitle[1] : Math.floor(mark * 100) / 100 })) }, i));
                                    })] })), units && units !== " " && ((0, jsx_runtime_1.jsx)("rect", { x: widthToUse - unitLabelWidth, y: 0, width: 1, height: height, fill: "white" }))] })), (0, jsx_runtime_1.jsx)(UnitContainer, Object.assign({ style: {
                            position: "absolute",
                            top: 3,
                            right: 6,
                            fontSize: 12,
                            color: "white",
                            width: unitLabelWidth - 8,
                            textAlign: "center",
                        } }, { children: units ? ((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, exports.unitsToLabel)(units) } })) : ("") }))] }))] })));
};
exports.ColorMapLegend = ColorMapLegend;
const ColorMapLegendContainer = styled_components_1.default.div `
  .katex .mathnormal {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
  }
`;
const UnitContainer = styled_components_1.default.div `
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
`;
const unitsToLabel = (units) => {
    if (units === "mm.hr^{-1}")
        return "mm";
    if (units === "percent" || units === "%")
        return "%";
    return katex_1.default.renderToString(units);
};
exports.unitsToLabel = unitsToLabel;
// A scale is generated for each colour range
// The scale is used to map a value to a colour, and vice versa
// If our legends were linear, we could just use a single scale, but...
// To support non-linear legends, we need a scale in between each colour range
const generateScales = (colorMap, totalRange, totalWidth) => {
    return colorMap
        .map((current, i) => {
        const next = colorMap[i + 1];
        if (!next)
            return;
        const range = [current[0], next[0]];
        const startingPoint = range[0] / totalRange;
        const endingPoint = range[1] / totalRange;
        const valueToXPoint = (0, d3_scale_1.scaleLinear)()
            .range([totalWidth * startingPoint, totalWidth * endingPoint])
            .domain(range);
        const valueToColour = (0, d3_scale_1.scaleLinear)()
            //@ts-ignore d3 does support colour ranges
            .range([current[1], next[1]])
            .domain(range);
        const colors = [current[1], next[1]];
        return { range, colors, valueToXPoint, valueToColour };
    })
        .filter((a) => {
        return a !== undefined;
    });
};
exports.generateScales = generateScales;
const valueToColour = (value, scales) => {
    const scale = scales.find((s) => s.range[0] <= value && s.range[1] >= value);
    if (!scale)
        return "rgba(0, 0, 0, 0)";
    return scale.valueToColour(value);
};
exports.valueToColour = valueToColour;
